import type { LinkProps } from 'next/link'
import Link from 'next/link'
import { forwardRef, type ReactNode } from 'react'

import { Button, type ButtonSharedProps } from './Button'

export interface ButtonLinkProps extends ButtonSharedProps, Omit<LinkProps, 'href'> {
  href?: LinkProps['href']
  className?: string
  children: ReactNode
}

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ size, variant, prefixIcon, suffixIcon, href = '#', className, ...props }, ref) => (
    <Button asChild size={size} variant={variant} prefixIcon={prefixIcon} suffixIcon={suffixIcon} className={className}>
      <Link {...props} href={href} ref={ref} />
    </Button>
  ),
)

ButtonLink.displayName = 'ButtonLink'
